var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"groupFields",style:({ margin: _vm.margin, padding: _vm.padding, width: _vm.width })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }